<template>
    <div class="home-overlay decorative-elements decorative-elements__in-home-overlay">
        <div class="home-overlay--wrapper">
            <div class="home-overlay--category-list">
                <div class="home-overlay--category-wrapper">
                    <div class="home-overlay--category-items">
                        <div class="home-overlay--category-item"
                                :class="getCategoryItemClasses(category)"
                                v-for="category in categories"
                                :key="category.id">
                            <category-menu-btn class="home-overlay--category-menu-btn"
                                    :color="category.color"
                                    :image="category.image"
                                    :title="category.title"
                                    :type="category.type"
                                    :facets="['home-overlay']"
                                    @click.native="onCategorySelected($event, category)"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="home-overlay--introduction">
                <div class="home-overlay--content">
                    <h1 class="u-reset home-overlay--title">
                        {{ 'HOME_OVERLAY.TITLE' | translate }}
                    </h1>

                    <snake-pattern class="decorative-elements--snake-pattern"/>

                    <p class="u-reset home-overlay--text">
                        {{ 'HOME_OVERLAY.LEAD' | translate }}
                    </p>

                    <span class="decorative-elements--spacer">
                        <ui-icon class="decorative-elements--spacer-icon" symbol="rhomb" size="medium"/>
                    </span>

                    <span class="decorative-elements--cta">
                        <router-link class="decorative-elements--cta-btn btn btn__primary btn__medium btn__uppercase"
                                :to="ctaLink">
                            {{ 'HOME_OVERLAY.CTA_LABEL' | translate }}
                        </router-link>
                    </span>

                    <div class="home-overlay--secondary-action">
                        <a class="home-overlay--secondary-action-btn" :href="activeRootCategory.url">
                            {{ 'HOME_OVERLAY.SECONDARY_ACTION_LABEL' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CategoryMenuBtn from 'framework/components/category-menu-btn/category-menu-btn';
    import SnakePattern from 'framework/global-components/snake-pattern/snake-pattern';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { MAP_APP_RECORD_NAMES } from 'framework/router/route-data-configs';
    import { getMainCategoryRoute } from 'framework/router/route-helpers';
    import { RESOURCE_TYPES } from 'util/project/helpers';

    export default {
        components: {
            CategoryMenuBtn,
            SnakePattern,
            UiIcon,
        },
        mixins: [
            bemMixin('home-overlay'),
        ],
        computed: {
            ...mapGetters('project-data', ['activeRootCategory', 'mainCategories', 'rootCategories']),
            categories() {
                return [...this.rootCategories, ...this.mainCategories];
            },
            ctaLink() {
                return { name: MAP_APP_RECORD_NAMES.MAP };
            },
        },
        methods: {
            getCategoryItemClasses({ type }) {
                return [
                    this.bemAdd(type === RESOURCE_TYPES.ROOT ? 'is-root-category' : '', 'category-item'),
                ];
            },
            /**
             * Choose a new category to display
             * @param {Event} $event - The event
             * @param {string} slug - The target slug
             */
            onCategorySelected($event, { slug, type }) {
                this.$router.push(getMainCategoryRoute({ slug, type }));
            },
        },
    };
</script>
